// ----------------------------------------------------------------------

export const carouselBreakpoints = {
  xs: '(min-width: 0px)',
  sm: '(min-width: 600px)',
  md: '(min-width: 900px)',
  lg: '(min-width: 1200px)',
  xl: '(min-width: 1536px)',
};
